import { z } from 'zod';

export const WebSocketMessageTypes = z.enum([
  'LOG_UPDATED',
  'EVENT',
  'SHOW_HIDE_STREAM',
  'ACTIVITY_EVENT_CREATED',
  'ACTIVITY_EVENT_REVIEWED',
  'STREAM_STATUS',
]);
export type WebSocketMessageType = z.infer<typeof WebSocketMessageTypes>;

export interface StreamStatusData {
  streamId: string;
  status: 'reconnecting' | 'online';
  since?: string;
  lastError?: string;
}

export interface StreamStatusMessage {
  event: 'STREAM_STATUS';
  data: StreamStatusData;
}

export interface LogUpdatedMessage<T = unknown> {
  event: 'LOG_UPDATED';
  data: T;
}

export const EventMessageCategorySchema = z.enum([
  'EVENT_CREATED',
  'EVENT_UPDATED',
  'MESSAGE_RECEIVED',
  'MATCHING_UPDATED',
]);
export type EventMessageCategory = z.infer<typeof EventMessageCategorySchema>;

export interface EventMessage<TEvent = unknown> {
  category: EventMessageCategory;
  event: TEvent;
}

export interface EventWsMessage<TEvent = unknown> {
  event: 'EVENT';
  data: EventMessage<TEvent>;
}
